import { makeApiUrl } from 'main/factories/http';
import { makeAuthorizeHttpClientDecorator } from 'main/factories/decorators';
import { GetTemplatesRanges } from 'domain/usecases/reports/get-templates-ranges';
import { RemoteGetTemplatesRanges } from 'data/usecases/reports/remote-get-templates-ranges';

export const makeRemoteTemplateRanges = (): GetTemplatesRanges => {
  return new RemoteGetTemplatesRanges(makeApiUrl('/templates/ranges'), makeAuthorizeHttpClientDecorator());
};
